import { Radio } from 'antd';
import React, { useEffect, useState } from 'react';
import { l2navoptions, relationOption, yesNoOptions } from '../../../../../../Helpers/InterBranchConstants';
import Dropdown from '../../../../../DropDown/Dropdown';
import './lifestyleandpreexisting.css'
import { useSelector, useDispatch } from "react-redux";
import { book_appointment, book_Videoconsultaton, Store_formData, update_lifestyle_preexisting_conditions_info } from "../../../../../../actions/InterBranchCoordinatorAction"
import { useHistory, useRouteMatch } from 'react-router-dom';
import { INTERBRANCH_CONDITIONS_UPDATE, INTERBRANCH_LIFESTYLE_UPDATE } from '../../../../../../actions/type';
import { validateDataForFields } from '../../../../../../Helpers/helperFunctions';

function LifestyleAndPreExistingCondition({ setActiveTop }) {


    let { path, url } = useRouteMatch();
    let dispatch = useDispatch();
    let history = useHistory()
    let reduxData = useSelector(state => state);
    let patientId = reduxData?.interBranchCoordinator?.interBranchRegisterPatient?.data?.info;
    let appointment_form = useSelector(state => state?.interBranchCoordinator?.appointment_form)
    let userDetails = JSON.parse(localStorage.getItem("userData"));
    const userId = userDetails.profileId;
    let patientDetails = useSelector(state => state.interBranchCoordinator?.interBranchPatientDetails?.data?.patientDetails);
    let { chosendoctorId, chosenDate,chosenTime,typeOfConsultation,couponCode } = reduxData?.interBranchCoordinator?.appointment_form;

    // //console.log("REdux in Lifestyle:",reduxData)
    let [formData, setFormData] = useState({
        alcohol: "",
        smoke: "",
        exercise: "",
        sleep: "",
        travel: "",
        anemiaSelf: "",
        anemiaFamily: "",
        asthmaSelf: "",
        asthmaFamily: "",
        diabetesSelf: "",
        diabetesFamily: "",
        cholesterolSelf: "",
        cholesterolFamily: "",
        thyroidDiseaseSelf: "",
        thyroidDiseaseFamily: "",
        heartDiseaseSelf: "",
        heartDiseaseFamily: "",
        strokeSelf: "",
        strokeFamily: "",
        glaucomaSelf: "",
        glaucomaFamily: "",
        highBloodPressureSelf: "",
        highBloodPressureFamily: "",
        cancerSelf: "",
        cancerFamily: "",
        tuberculosisSelf: "",
        tuberculosisFamily: "",
        allergiesSelf: "",
        allergiesFamily: ""

    })

    const [isEditted, setEditted] = useState(false)


    useEffect(() => {

        syncFormDataWithRedux()
    }, [])

    useEffect(() => {
        syncFormDataWithRedux()
    }, [appointment_form])





    let handleChangeFormItem = ({ key, value, owner }) => {
        console.log("Key:", key, "value:", value, "owner:", owner)

        setEditted(true)
        if (key) {

            setFormData({ ...formData, [key + owner]: value })

        }

    }


    let handleChangeFormItemLifestyle = ({ key, value }) => {

        setEditted(true)

        if (key) {

            setFormData({ ...formData, [key]: value })

        }


    }


    let saveData = () => {

        let submissionData = {
            patientLifeStyles: {
                alcohol: formData.alcohol,
                smoke: formData.smoke,
                exercise: formData.exercise,
                sleep: formData.sleep,
                travel: formData.travel
            },
            patientPreExistingConditions: {
                anemia: {
                    condition: "Anemia",
                    self: formData.anemiaSelf,
                    family: formData.anemiaFamily
                },
                asthma: {
                    condition: "Asthma",
                    self: formData.asthmaSelf,
                    family: formData.asthmaFamily
                },
                diabetes: {
                    condition: "Diabetes",
                    self: formData.diabetesSelf,
                    family: formData.diabetesFamily
                },
                cholesterol: {
                    condition: "Cholesterol",
                    self: formData.cholesterolSelf,
                    family: formData.cholesterolFamily
                },
                thyroidDisease: {
                    condition: "Thyroid Disease",
                    self: formData.thyroidDiseaseSelf,
                    family: formData.thyroidDiseaseFamily
                },
                heartDisease: {
                    condition: "Heart Disease",
                    self: formData.heartDiseaseSelf,
                    family: formData.heartDiseaseFamily
                },
                stroke: {
                    condition: "Stroke",
                    self: formData.strokeSelf,
                    family: formData.strokeFamily
                },
                glaucoma: {
                    condition: "Glaucoma",
                    self: formData.glaucomaSelf,
                    family: formData.glaucomaFamily
                },
                highBloodPressure: {
                    condition: "High Blood Pressure",
                    self: formData.highBloodPressureSelf,
                    family: formData.highBloodPressureFamily
                },
                cancer: {
                    condition: "Cancer",
                    self: formData.cancerSelf,
                    family: formData.cancerFamily
                },
                tuberculosis: {
                    condition: "Tuberculosis",
                    self: formData.tuberculosisSelf,
                    family: formData.tuberculosisFamily
                },
                allergies: {
                    condition: "Allergies",
                    self: formData.allergiesSelf,
                    family: formData.allergiesFamily
                }
            }

        }

        dispatch(
            Store_formData({
                ...appointment_form,
                ...submissionData

            })).then(() => {
                try {
                    console.log("Appointment Details in lifestyle Page b4 calling API", submissionData)
                    console.log("Form Data:", formData)
                    dispatch(update_lifestyle_preexisting_conditions_info(patientId, submissionData));
                    setActiveTop(l2navoptions[2])
                    history.push(`/dashboard/${url.includes("bookandconsult") ? "bookandconsult" : "scheduleappointment"}/patientmedical/allergies`)

                } catch (error) {
                    //console.log("Error in profile API", error);
                }
            })


    }

    let videoconsultation = () => {
        try {
                dispatch(book_Videoconsultaton(patientId, userId, chosendoctorId, typeOfConsultation, couponCode, chosenTime, chosenDate, appointment_form)).
                    then((res) => {
    
                        if (res.data.appointmentId != "Time slot already choosen by some other person. Please try with different slot, Sorry for the inconvenience.") {
                    
                            localStorage.setItem("AppointmentId", res.data.appointmentId)
                            history.push("/joinconsultation/"+res.data.appointmentId);
                        }
                        
                    })
            } catch (error) {
                //console.log("Error in book_appointment API", error);
            }
    }

    let syncFormDataWithRedux = () => {
        setFormData({
            // highbp: appointment_form?.patientLifeStyles?.highbp,
            alcohol: appointment_form?.patientLifeStyles?.alcohol,
            smoke: appointment_form?.patientLifeStyles?.smoke,
            exercise: appointment_form?.patientLifeStyles?.exercise,
            // medication: appointment_form?.patientLifeStyles?.medication,
            sleep: appointment_form?.patientLifeStyles?.sleep,
            // chronic: appointment_form?.patientLifeStyles?.chronic,
            travel: appointment_form?.patientLifeStyles?.travel,

            anemiaSelf: appointment_form?.patientPreExistingConditions?.anemia?.self,
            anemiaFamily: appointment_form?.patientPreExistingConditions?.anemia?.family,
            asthmaSelf: appointment_form?.patientPreExistingConditions?.asthma?.self,
            asthmaFamily: appointment_form?.patientPreExistingConditions?.asthma?.family,
            diabetesSelf: appointment_form?.patientPreExistingConditions?.diabetes?.self,
            diabetesFamily: appointment_form?.patientPreExistingConditions?.diabetes?.family,
            cholesterolSelf: appointment_form?.patientPreExistingConditions?.cholesterol?.self,
            cholesterolFamily: appointment_form?.patientPreExistingConditions?.cholesterol?.family,
            thyroidDiseaseSelf: appointment_form?.patientPreExistingConditions?.thyroidDisease?.self,
            thyroidDiseaseFamily: appointment_form?.patientPreExistingConditions?.thyroidDisease?.family,
            heartDiseaseSelf: appointment_form?.patientPreExistingConditions?.heartDisease?.self,
            heartDiseaseFamily: appointment_form?.patientPreExistingConditions?.heartDisease?.family,
            strokeSelf: appointment_form?.patientPreExistingConditions?.stroke?.self,
            strokeFamily: appointment_form?.patientPreExistingConditions?.stroke?.family,
            glaucomaSelf: appointment_form?.patientPreExistingConditions?.glaucoma?.self,
            glaucomaFamily: appointment_form?.patientPreExistingConditions?.glaucoma?.family,
            highBloodPressureSelf: appointment_form?.patientPreExistingConditions?.highBloodPressure?.self,
            highBloodPressureFamily: appointment_form?.patientPreExistingConditions?.highBloodPressure?.family,
            cancerSelf: appointment_form?.patientPreExistingConditions?.cancer?.self,
            cancerFamily: appointment_form?.patientPreExistingConditions?.cancer?.family,
            tuberculosisSelf: appointment_form?.patientPreExistingConditions?.tuberculosis?.self,
            tuberculosisFamily: appointment_form?.patientPreExistingConditions?.tuberculosis?.family,
            allergiesSelf: appointment_form?.patientPreExistingConditions?.allergies?.self,
            allergiesFamily: appointment_form?.patientPreExistingConditions?.allergies?.family
        })
    }


    let isScheduled = () => {

        return url.includes("scheduleappointment")

    }




    return (

        <div className='lsapec-container'>


            <div className="tables-container">
                <div className="table-container">
                    <div className="tittle">Lifestyle</div>

                    <table className='lpec-table'>
                        <tr>
                            <th colSpan={3}>Conditions</th>
                        </tr>

                        <tbody>
                            <tr>
                                {/* <td>Blood Pressure</td>                             

                                <td>
                                    <Radio.Group name={formData.highbp} value={formData.highbp}>

                                        <Radio value={"Yes"}  onClick={(e) => { handleChangeFormItem({ key: "highbp", value: "Yes"}) }}>Yes</Radio>

                                        <Radio value={"No"}  onClick={(e) => { handleChangeFormItem({ key: "highbp", value: "No" }) }}>No</Radio>
                                    </Radio.Group>
                                </td> */}


                            </tr>

                            <tr>
                                <td>Alcohol</td>

                                <td>
                                    <Radio.Group name={formData.alcohol} value={formData.alcohol}>

                                        <Radio value={"Yes"} onClick={(e) => { handleChangeFormItemLifestyle({ key: "alcohol", value: "Yes" }) }}>Yes</Radio>

                                        <Radio value={"No"} onClick={(e) => { handleChangeFormItemLifestyle({ key: "alcohol", value: "No" }) }}>No</Radio>
                                    </Radio.Group>
                                </td>


                            </tr>

                             <tr>
                                <td>Exercise</td>

                                <td>
                                    <Radio.Group name={formData.exercise} value={formData.exercise}>

                                        <Radio value={"Yes"} onClick={(e) => { handleChangeFormItemLifestyle({ key: "exercise", value: "Yes" }) }}>Yes</Radio>

                                        <Radio value={"No"} onClick={(e) => { handleChangeFormItemLifestyle({ key: "exercise", value: "No" }) }}>No</Radio>
                                    </Radio.Group>
                                </td>


                            </tr>

                            <tr>
                                <td>Sleep</td>

                                <td>
                                    <Radio.Group name={formData.sleep} value={formData.sleep}>

                                        <Radio className='mr-2' value={"Yes"} onClick={(e) => { handleChangeFormItemLifestyle({ key: "sleep", value: "Yes" }) }}>Yes</Radio>

                                        <Radio value={"No"} onClick={(e) => { handleChangeFormItemLifestyle({ key: "sleep", value: "No" }) }}>No</Radio>

                                    </Radio.Group>
                                </td>

                            </tr>
                           
                            <tr>
                                <td>Smoke</td>

                                <td>
                                    <Radio.Group name={formData.smoke} value={formData.smoke}>

                                        <Radio value={"Yes"} onClick={(e) => { handleChangeFormItemLifestyle({ key: "smoke", value: "Yes" }) }}>Yes</Radio>

                                        <Radio value={"No"} onClick={(e) => { handleChangeFormItemLifestyle({ key: "smoke", value: "No" }) }}>No</Radio>
                                    </Radio.Group>
                                </td>


                            </tr>
                           


                            <tr>
                                <td>Travel</td>

                                <td>
                                    <Radio.Group name={formData.travel} value={formData.travel}>

                                        <Radio className='mr-2' value={"Yes"} onClick={(e) => { handleChangeFormItemLifestyle({ key: "travel", value: "Yes" }) }}>Yes</Radio>

                                        <Radio value={"No"} onClick={(e) => { handleChangeFormItemLifestyle({ key: "travel", value: "No" }) }}>No</Radio>

                                    </Radio.Group>
                                </td>

                            </tr>

                        </tbody>
                    </table>
                </div>

                <div className="table-container">
                    <div className="tittle">Pre-Exisiting Conditions</div>

                    <table className='lifestyle-table '>
                        <tr>
                            <th>Conditions</th>
                            <th>For Self</th>
                            <th>In Family</th>
                        </tr>

                        <tbody>
                            <tr>
                                <td>Allergies</td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={yesNoOptions}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.allergiesSelf)}
                                        onChange={(e) => { handleChangeFormItem({ key: "allergies", owner: "Self", value: e }) }}
                                        isV2
                                    />
                                </td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={relationOption}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.allergiesFamily)}
                                        onChange={(e) => { handleChangeFormItem({ key: "allergies", owner: "Family", value: e }) }}
                                        isV2
                                    />
                                </td>

                            </tr>
                            <tr>
                                <td>Anemia</td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={yesNoOptions}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.anemiaSelf)}
                                        onChange={(e) => { handleChangeFormItem({ key: "anemia", owner: "Self", value: e }) }}
                                        isV2
                                    />
                                </td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={relationOption}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.anemiaFamily)}

                                        onChange={(e) => { handleChangeFormItem({ key: "anemia", owner: "Family", value: e }) }}
                                        isV2
                                    />
                                </td>

                            </tr>

                            <tr>
                                <td>Asthma</td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={yesNoOptions}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.asthmaSelf)}

                                        onChange={(e) => { handleChangeFormItem({ key: "asthma", owner: "Self", value: e }) }}
                                        isV2
                                    />
                                </td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={relationOption}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.asthmaFamily)}
                                        onChange={(e) => { handleChangeFormItem({ key: "asthma", owner: "Family", value: e }) }}
                                        isV2
                                    />
                                </td>

                            </tr>

                            <tr>
                                <td>Cancer</td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={yesNoOptions}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.cancerSelf)}

                                        onChange={(e) => { handleChangeFormItem({ key: "cancer", owner: "Self", value: e }) }}
                                        isV2
                                    />
                                </td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={relationOption}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.cancerFamily)}

                                        onChange={(e) => { handleChangeFormItem({ key: "cancer", owner: "Family", value: e }) }}
                                        isV2
                                    />
                                </td>

                            </tr>
                            <tr>
                                <td>Cholesterol</td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={yesNoOptions}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.cholesterolSelf)}

                                        onChange={(e) => { handleChangeFormItem({ key: "cholesterol", owner: "Self", value: e }) }}
                                        isV2
                                    />
                                </td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={relationOption}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.cholesterolFamily)}

                                        onChange={(e) => { handleChangeFormItem({ key: "cholesterol", owner: "Family", value: e }) }}
                                        isV2
                                    />
                                </td>

                            </tr>
                            <tr>
                                <td>Diabetes</td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={yesNoOptions}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.diabetesSelf)}

                                        onChange={(e) => { handleChangeFormItem({ key: "diabetes", owner: "Self", value: e }) }}
                                        isV2
                                    />
                                </td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={relationOption}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.diabetesFamily)}

                                        onChange={(e) => { handleChangeFormItem({ key: "diabetes", owner: "Family", value: e }) }}
                                        isV2
                                    />
                                </td>

                            </tr>
                            <tr>
                                <td>Glaucoma</td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={yesNoOptions}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.glaucomaSelf)}

                                        onChange={(e) => { handleChangeFormItem({ key: "glaucoma", owner: "Self", value: e }) }}
                                        isV2
                                    />
                                </td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={relationOption}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.glaucomaFamily)}

                                        onChange={(e) => { handleChangeFormItem({ key: "glaucoma", owner: "Family", value: e }) }}
                                        isV2
                                    />
                                </td>

                            </tr>


                            <tr>
                                <td>Heart Disease</td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={yesNoOptions}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.heartDiseaseSelf)}

                                        onChange={(e) => { handleChangeFormItem({ key: "heartDisease", owner: "Self", value: e }) }}
                                        isV2
                                    />
                                </td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={relationOption}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.heartDiseaseFamily)}

                                        onChange={(e) => { handleChangeFormItem({ key: "heartDisease", owner: "Family", value: e }) }}
                                        isV2
                                    />
                                </td>

                            </tr>
                            <tr>
                                <td>High Blood Pressure</td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={yesNoOptions}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.highBloodPressureSelf)}

                                        onChange={(e) => { handleChangeFormItem({ key: "highBloodPressure", owner: "Self", value: e }) }}
                                        isV2
                                    />
                                </td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={relationOption}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.highBloodPressureFamily)}

                                        onChange={(e) => { handleChangeFormItem({ key: "highBloodPressure", owner: "Family", value: e }) }}
                                        isV2
                                    />
                                </td>

                            </tr>
                            <tr>
                                <td>Stroke</td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={yesNoOptions}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.strokeSelf)}

                                        onChange={(e) => { handleChangeFormItem({ key: "stroke", owner: "Self", value: e }) }}
                                        isV2
                                    />
                                </td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={relationOption}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.strokeFamily)}

                                        onChange={(e) => { handleChangeFormItem({ key: "stroke", owner: "Family", value: e }) }}
                                        isV2
                                    />
                                </td>

                            </tr>




                            <tr>
                                <td>Thyroid Disease</td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={yesNoOptions}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.thyroidDiseaseSelf)}

                                        onChange={(e) => { handleChangeFormItem({ key: "thyroidDisease", owner: "Self", value: e }) }}
                                        isV2
                                    />
                                </td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={relationOption}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.thyroidDiseaseFamily)}

                                        onChange={(e) => { handleChangeFormItem({ key: "thyroidDisease", owner: "Family", value: e }) }}
                                        isV2
                                    />
                                </td>

                            </tr>


                            <tr>
                                <td>Tuberculosis</td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={yesNoOptions}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.tuberculosisSelf)}

                                        onChange={(e) => { handleChangeFormItem({ key: "tuberculosis", owner: "Self", value: e }) }}
                                        isV2
                                    />
                                </td>

                                <td>
                                    <Dropdown
                                        width={121}
                                        data={relationOption}
                                        placeholder="Select"
                                        value={validateDataForFields(formData.tuberculosisFamily)}

                                        onChange={(e) => { handleChangeFormItem({ key: "tuberculosis", owner: "Family", value: e }) }}
                                        isV2
                                    />
                                </td>

                            </tr>



                        </tbody>
                    </table>
                </div>
            </div>

            <div className="button-container">

                <button className='submt-btn' disabled={!isEditted} onClick={saveData}>SAVE</button>

                {/* {
                    isScheduled() &&
                    <button className='join-btn' onClick={bookappointment}>BOOK APPOINTMENT</button>
                    // :
                    // <button disabled={!isCouponCodeVerified()} className='join-btn' onClick={() => setButtonClicked("Book")}>BOOK APPOINTMENT</button>
                } */}
                {
                    !isScheduled() &&
                    <button className='join-btn' onClick={videoconsultation}>SKIP AND JOIN CONSULTATION</button>
                    // :
                    // <button disabled={!isCouponCodeVerified()} className='join-btn' onClick={() => setButtonClicked("Book")}>BOOK APPOINTMENT</button>
                }



            </div>


        </div>

    );
}

export default LifestyleAndPreExistingCondition;
